import React, { useState } from 'react';
import axios from 'axios';

export default function AgentLogin() {
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState('phone');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const sendOtp = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.post('/api/agents/send-otp', { phone });
      if (res.data.success) setStep('otp');
      else setError(res.data.message);
    } catch (e) {
      setError('Failed to send OTP');
    }
    setLoading(false);
  };

  const verifyOtp = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.post('/api/agents/verify-otp', { phone, otp });
      if (res.data.success) {
        localStorage.setItem('agent_token', res.data.token);
        localStorage.setItem('agent_user', JSON.stringify(res.data.agent));
        localStorage.setItem('agent_id', res.data.agent.id);
        window.location.href = '/agent-inbox';
      } else setError(res.data.message);
    } catch (e) {
      setError('Failed to verify OTP');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'white', borderRadius: '16px', padding: '40px', width: '360px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'linear-gradient(135deg, #7c3aed, #6d28d9)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 900, color: '#fff', margin: '0 auto 12px' }}>V</div>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 600 }}>Agent Login</h2>
          <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#888' }}>VFlow WhatsApp CRM</p>
        </div>

        {step === 'phone' ? (
          <>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '6px' }}>WhatsApp Number</label>
              <div style={{ display: 'flex', gap: '8px' }}>
                <span style={{ padding: '10px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '13px', background: '#f9f9f9' }}>+91</span>
                <input
                  placeholder="9876543210"
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                  style={{ flex: 1, padding: '10px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '13px', outline: 'none' }}
                />
              </div>
            </div>
            {error && <p style={{ color: '#e53e3e', fontSize: '12px', marginBottom: '12px' }}>{error}</p>}
            <button onClick={sendOtp} disabled={loading || !phone}
              style={{ width: '100%', padding: '12px', background: '#25D366', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 500, cursor: 'pointer' }}>
              {loading ? 'Sending...' : 'Send OTP via WhatsApp'}
            </button>
          </>
        ) : (
          <>
            <p style={{ fontSize: '13px', color: '#555', marginBottom: '16px' }}>OTP sent to WhatsApp: +91 {phone}</p>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ fontSize: '13px', fontWeight: 500, display: 'block', marginBottom: '6px' }}>Enter OTP</label>
              <input
                placeholder="6-digit OTP"
                value={otp}
                onChange={e => setOtp(e.target.value)}
                style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box' }}
              />
            </div>
            {error && <p style={{ color: '#e53e3e', fontSize: '12px', marginBottom: '12px' }}>{error}</p>}
            <button onClick={verifyOtp} disabled={loading || !otp}
              style={{ width: '100%', padding: '12px', background: '#7c3aed', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 500, cursor: 'pointer' }}>
              {loading ? 'Verifying...' : 'Verify OTP'}
            </button>
            <button onClick={() => setStep('phone')}
              style={{ width: '100%', padding: '12px', background: 'transparent', color: '#888', border: 'none', fontSize: '13px', cursor: 'pointer', marginTop: '8px' }}>
              Change Number
            </button>
          </>
        )}
      </div>
    </div>
  );
}
